import { useEffect, useRef, useState } from "react";

export default function CoordinateTracker() {
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const raf = useRef(null);

  useEffect(() => {
    const onMove = (e) => {
      if (raf.current) return;
      raf.current = requestAnimationFrame(() => {
        setPos({ x: e.clientX, y: e.clientY });
        raf.current = null;
      });
    };
    window.addEventListener("mousemove", onMove, { passive: true });
    return () => {
      window.removeEventListener("mousemove", onMove);
      if (raf.current) cancelAnimationFrame(raf.current);
    };
  }, []);

  return (
    <div
      data-testid="cad-coordinate-tracker"
      className="pointer-events-none fixed bottom-4 right-4 z-40 hidden rounded-sm border border-cad/25 bg-surface/80 px-3 py-2 font-mono text-[10px] tracking-[0.2em] text-cad/80 backdrop-blur-md md:block"
    >
      X: {String(pos.x).padStart(4, "0")} · Y: {String(pos.y).padStart(4, "0")} · SCALE 1:1
    </div>
  );
}
